import { Component, inject } from '@angular/core'

import { CalendlyService } from '../../modules/shared/services/calendly.service'

@Component({
  standalone: false,
  templateUrl: './hunt-gate.component.html',
  styleUrls: ['./hunt-gate.component.scss'],
})
export class HuntGateComponent {
  private calendlyService = inject(CalendlyService)

  public talkToCyborg(): void {
    this.calendlyService.talkToCyborg()
  }

  public learnMore(): void {
    window.open(
      'https://www.intel471.com/use-cases/hunt-management-module',
      '_blank',
      'noopener,noreferrer',
    )
  }
}
